import { Fragment, h } from "preact";
import { AppPage } from '../../../_common/components/app-page'
import {C, CF, F} from '../../../_common/layout'
import { RadioCheckbox } from '../../../_common/forms/components/components'
import {useEffect, useState} from 'preact/hooks'
import { useHistory, useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import ButtonSpinner from '../../../_common/components/buttons/buttonSpinner/buttonSpinner'
import { t } from '../../../_i18n'
import { isSpanishUser } from "../../../_common/utils/getLang";
import {fetchProtoMeta, fetchStatusAccountPrecontract} from "../actions";
import {toastService} from "../../../_services/toast-service";
import usePrecontractFctMeta from "../../../fct/hooks/usePrecontractFctMeta";
import {fetchStatus as fetchStatusAccount} from "../../student/actions";

export function TermsExemption () {
  const [check, setCheck] = useState(false);
  const [checkPD, setCheckPD] = useState(false);
  const [loading, setLoading] = useState(false);
  const shopId = useSelector(state => state.status.student_meta.shop_id);
  const history = useHistory();
  const { proto_meta } = useSelector(state => ({ proto_meta: state.exemption_100.proto_meta }));
  const dispatch = useDispatch();
  const userId = useSelector(state => state.auth.loggedUser.id)
  const { id } = useParams();
  const meta = usePrecontractFctMeta(id);

  const loadPrecontracts = async () => {
    try {
      await dispatch(fetchProtoMeta(id));
    } catch (error) {
      toastService.showToast({ message: t("Error al cargar los precontracts."), type: 'danger' });
    }
  };

  useEffect(() => {
    loadPrecontracts().then();
  }, []);

  const handleSubmit = () => {
    setLoading(true);
    fetchStatusAccountPrecontract(id)
      .then(async (data) => {
        if (data.status.toLowerCase() === 'ok') {
          await dispatch(fetchStatusAccount(userId))
          history.push(`/exemption/${id}`);
        }
      })
      .catch(() => setLoading(false))
  };

  return (
    <AppPage className="max-width-980">
      <F className="max-width-980">
        <C>
          <div className="back breadcrumb-item cursor-pointer d-none sm-d-block width-fit-content" onClick={history.goBack}>← {t('Volver')}</div>
          <h1 className='hero m-bottom m-top'>{t('Normativa exencion')}</h1>

          <CF className="card m-bottom">
            <div className={"p-x2-top p-x2-bottom t-justify px-8"}>
              {(() => {
                if (isSpanishUser(shopId)) {
                    return (
                        <div>
                          <h2 className='hero m-bottom font-heavy'>{t('Normativa exencion')}</h2>
                          <span>
                            <a href={proto_meta?.regulations?.link} target='_blank' className='font-color-149BAB'>{t('consultar la normativa de FCT')} {proto_meta?.regulations?.name}</a>.
                          </span>
                        </div>
                    );
                } else if (shopId == 24 || shopId == 44) {
                  return (
                      <div dangerouslySetInnerHTML={{__html: t(meta.formative_zone === 'MAD' ? 'fct_terms_mad' : 'fct_terms_cat')}} />
                    );
                }
              })()}

              {!meta.signed && (
                  <Fragment>
                    <RadioCheckbox type='checkbox' className='m-top'
                                   label={t('lectura_estancia')}
                                   defaultValue={check} onChange={(e) => setCheck(e)} />
                  </Fragment>
              )}
            </div>
          </CF>

          <CF className="card m-bottom px-8">
            <div className={"p-x2-top p-x2-bottom t-justify"}>
              <div>
                <h2 className='hero m-bottom font-heavy'>{t('fct_rgpd_title')}</h2>
                <div dangerouslySetInnerHTML={{__html: t('fct_rgpd_info')}}/>
              </div>

              {!meta.signed && (
                  <Fragment>
                    <RadioCheckbox type='checkbox' className='m-top'
                                   label={t('fct_rgpd_checkbox')}
                                   defaultValue={checkPD} onChange={(e) => setCheckPD(e)}/>
                  </Fragment>
              )}
            </div>
          </CF>

          <ButtonSpinner classNameContainer='m-top' disabled={!check || !checkPD} onClick={handleSubmit}
                         showSpinner={loading}>{t('Aceptar y enviar')}</ButtonSpinner>

        </C>
      </F>
    </AppPage>
  )
}

